/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { LogSelectors } from 'ogc-processes-components';
import { useAuthService } from '@/hooks/useAuthService';
import { useQuery } from '@tanstack/react-query';
import { Skeleton } from 'primereact/skeleton';
type Props = React.ComponentProps<typeof LogSelectors>;

export const LogsAuthenticated: React.FC<Props> = (props: Props) => {
  const { injectedToken } = useAuthService();

  const { data: logs, isFetching } = useQuery({
    queryKey: ['inject_token', props.logsHref, injectedToken],
    queryFn: async () => {
      const promises = props.logsHref.map((item) => (injectedToken ? injectedToken(item) : item));
      const res = await Promise.all(promises);
      return res;
    },
    refetchOnWindowFocus: false
  });
  return isFetching ? (
    <Skeleton width="100%" height="2rem" className="my-2" />
  ) : (
    <LogSelectors {...props} logsHref={logs ?? []} />
  );
};
